import { ComposeDeleteDialog } from '@app/modules/compose/screens/delete/ComposeDeleteDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { defineMessage, FormattedMessage } from 'react-intl';
import { useComposition } from '../hooks/useComposition';
import { Station } from '@app/core/types/stations';

const composeDeleteMenuItemMessage = defineMessage({
  id: 'common.actions.delete',
  defaultMessage: 'Eliminar',
});

interface ComposeViewOverflowActionsProps {
  station: Station;
}

/**
 * Overflow menu (three dots) for composition view header: hosts delete behind a confirmation dialog.
 */
export function ComposeViewOverflowActions({ station }: ComposeViewOverflowActionsProps) {
  const { composition } = useComposition();
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const menuOpen = Boolean(menuAnchor);

  function handleOpenMenu(event: MouseEvent<HTMLElement>) {
    setMenuAnchor(event.currentTarget);
  }

  function handleCloseMenu() {
    setMenuAnchor(null);
  }

  function handleRequestDelete() {
    handleCloseMenu();
    setDeleteDialogOpen(true);
  }

  return (
    <>
      <IconButton size="small" color="secondary" onClick={handleOpenMenu}>
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={menuAnchor} open={menuOpen} onClose={handleCloseMenu}>
        <MenuItem onClick={handleRequestDelete} sx={{ color: 'error.main' }}>
          <ListItemIcon sx={{ color: 'inherit' }}>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>
            <FormattedMessage {...composeDeleteMenuItemMessage} />
          </ListItemText>
        </MenuItem>
      </Menu>
      <ComposeDeleteDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        station={station}
        composition={composition}
      />
    </>
  );
}
